var render = function render(){var _vm=this,_c=_vm._self._c;return _c('HistoryTabTemplate',{attrs:{"items":_vm.items,"loading":_vm.loading}},_vm._l((_vm.items),function(item,itemIndex){return _c('QuestionCard',{key:`question-${itemIndex}`,attrs:{"data-qa":`question-${itemIndex}`,"item":item},on:{"openChat":val => _vm.$emit('openChat', val)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }